import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./report/scss/viewRadiology.module.scss";
import { Row } from "react-bootstrap";
import classNames from "classnames";
import qrcode from "../../../images/qr.png";
import {
  getAllRadiologyReport,
  getOutSourceToRadiologyReport,
  getOutSourceFromRadiologyReport,
} from "../../../store/slices/radiologyReport";
import DOMPurify from "dompurify";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const RadiologyPDF = () => {
  const [showPDF, setShowPDF] = useState(false);
  const dispatch = useDispatch();
  const { userInfo, token } = useSelector((state) => state.auth);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const clinic = clinicInfo && clinicInfo?.length > 0 ? clinicInfo[0] : [];
  const allReportsId = sessionStorage.getItem("allReportsId");
  const outSourceToId = sessionStorage.getItem("outSourceToId");
  const outSourceFromId = sessionStorage.getItem("outSourceFromId");
  const { radiologyReports } = useSelector((state) => state.radiologyReport);
  const newRadiologyReport =
    radiologyReports && radiologyReports.length > 0
      ? radiologyReports[0]
      : null;
  const reportRef = useRef();
  const clinicId =clinicInfo?.[0]?.clinicId;

  useEffect(() => {
    if (allReportsId) {
      dispatch(
        getAllRadiologyReport({ clinicId, reportId: allReportsId, token }),
      );
    } else if (outSourceToId) {
      dispatch(
        getOutSourceToRadiologyReport({
          clinicId,
          reportId: outSourceToId,
          token,
        }),
      );
    } else if (outSourceFromId) {
      dispatch(
        getOutSourceFromRadiologyReport({
          clinicId,
          reportId: outSourceFromId,
          token,
        }),
      );
    }
  }, [
    dispatch,
    userInfo,
    allReportsId,
    outSourceToId,
    outSourceFromId,
    clinicInfo,
    token,
  ]);

  const downloadInvoice = async () => {
    await setShowPDF(true);
    const input = reportRef.current;
    await html2canvas(input, { scale: 2, useCORS: true, allowTaint: true })
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const imgWidth = 210;
        const pageHeight = 295;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let heightLeft = imgHeight;
        let position = 0;
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
        while (heightLeft >= 0) {
          position = heightLeft - imgHeight;
          pdf.addPage();
          pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }
        pdf.save("radiology_report.pdf");
        setShowPDF(false);
      })
      .catch((err) => console.log("Error generating PDF: ", err));
  };

  const invoiceHeaderLeft = () => (
    <div className={styles.radiologyInvoice}>
      <div className="mt-1 col-sm-6">
        <div className="brand-logo mb-3">
          <div
            style={{
              backgroundImage: `url(${clinic?.hospitalInfo?.pdfHeader})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              width: "370px",
              height: "80px",
              objectFit: "cover",
            }}
          ></div>
        </div>
        <span className="d-block">
          {clinic?.clinicAddress ? (
            <>
              {clinic.clinicAddress.plot && `${clinic.clinicAddress.plot}, `}
              {clinic.clinicAddress.area && `${clinic.clinicAddress.area}, `}
              {clinic.clinicAddress.street &&
                `${clinic.clinicAddress.street}, `}
              {clinic.clinicAddress.landMark &&
                `${clinic.clinicAddress.landMark}, `}
              {clinic.clinicAddress.city?.name &&
                `${clinic.clinicAddress.city.name}, `}
              {clinic?.clinicAddress?.state?.name &&
                `${clinic.clinicAddress.state.name}, `}
              {clinic.clinicAddress.country?.name &&
                `${clinic.clinicAddress.country.name}, `}
              {clinic.clinicAddress.pin && clinic.clinicAddress.pin}
            </>
          ) : (
            "N/A"
          )}
        </span>
        <small className="d-block mt-1">
          <strong>Website</strong> : {clinic?.hospitalInfo?.web_address}
        </small>
        <small className="d-block mt-1">
          <strong>Contact No</strong> :{clinic?.userId?.phone}
        </small>
        <small className="d-block mt-1">
          <strong>GSTIN</strong> : {clinic?.accountInfo?.gst}
        </small>
      </div>
      <div className="mt-1 col-xl-6">
        <div className="row d-flex justify-content-between">
          <div className="col-sm-9">
            <h6>From:</h6>
            <div className="mt-1">
              <strong>Webz Poland</strong>
            </div>
            <div className="mt-1">Madalinskiego 8 71-101 Szczecin, Poland</div>
            <div className="mt-1"></div>
            <div className="mt-1">Email: info@webz.com.pl</div>
            <div className="mt-1">Phone: +48 444 666 3333</div>
          </div>
          <div className="col-sm-3 d-flex justify-content-end">
            {clinic?.hospitalInfo?.displayISOlogo && (
              <div
                style={{
                  backgroundImage: `url(${clinic.hospitalInfo.ISOLogo})`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  width: "60px",
                  height: "60px",
                  objectFit: "cover",
                }}
              ></div>
            )}
          </div>
        </div>
      </div>
    </div>
  );

  const invoiceHeaderRight = () => (
    <div className={styles.radiologyInvoice}>
      <div className="mt-1 col-xl-6">
        <h6>From:</h6>
        <div className="mt-1">
          <strong>Webz Poland</strong>
        </div>
        <div className="mt-1">Madalinskiego 8</div>
        <div className="mt-1">71-101 Szczecin, Poland</div>
        <div className="mt-1">Email: info@webz.com.pl</div>
        <div className="mt-1">Phone: +48 444 666 3333</div>
      </div>
      <div className="mt-1 col-sm-6 d-flex justify-content-end">
        <div className="row">
          <div className="col-sm-9">
            <div className="brand-logo mb-3">
              {clinic?.hospitalInfo?.pdfHeader && (
                <img
                  src={clinic?.hospitalInfo?.pdfHeader}
                  className="img-fluid"
                  alt=""
                  style={{ width: "250px" }}
                />
              )}
            </div>
            <span className="d-block">
              {clinic?.clinicAddress ? (
                <>
                  {clinic.clinicAddress.plot &&
                    `${clinic.clinicAddress.plot}, `}
                  {clinic.clinicAddress.area &&
                    `${clinic.clinicAddress.area}, `}
                  {clinic.clinicAddress.street &&
                    `${clinic.clinicAddress.street}, `}
                  {clinic.clinicAddress.landMark &&
                    `${clinic.clinicAddress.landMark}, `}
                  {clinic.clinicAddress.city?.name &&
                    `${clinic.clinicAddress.city.name}, `}
                  {clinic?.clinicAddress?.state?.name &&
                    `${clinic.clinicAddress.state.name}, `}
                  {clinic.clinicAddress.country?.name &&
                    `${clinic.clinicAddress.country.name}, `}
                  {clinic.clinicAddress.pin && clinic.clinicAddress.pin}
                </>
              ) : (
                "N/A"
              )}
            </span>
            <small className="d-block mt-1">
              <strong>Website</strong> : {clinic?.hospitalInfo?.web_address}
            </small>
            <small className="d-block mt-1">
              <strong>Contact No</strong> :{clinic?.userId?.phone}
            </small>
            <small className="d-block mt-1">
              <strong>GSTIN</strong> : {clinic?.accountInfo?.gst}
            </small>
          </div>
          <div className="col-sm-3 text-end">
            <img
              src={clinic?.hospitalInfo?.ISOLogo}
              className="img-fluid width110"
              alt=""
              style={{ width: "70px" }}
            />
          </div>
        </div>
      </div>
    </div>
  );

  const invoiceHeaderCenter = () => (
    <div className={classNames("row", styles.radiologyInvoice)}>
      <div className="mt-1 col-sm-9 d-flex justify-content-between">
        <div className="brand-logo mb-3">
          <img
            className="logo-abbr me-2"
            src={clinic?.hospitalInfo?.pdfHeader}
            alt=""
          />
        </div>
      </div>
      <div className="mt-1 col-sm-3 text-end">
        {clinic?.hospitalInfo?.displayISOlogo && (
          <img
            src={clinic.hospitalInfo.ISOLogo}
            className="img-fluid width110"
            alt=""
            style={{ width: "70px" }}
          />
        )}
      </div>
      <div className="mt-1 col-sm-12">
        <span className="d-block">
          {clinic?.clinicAddress ? (
            <>
              {clinic.clinicAddress.plot && `${clinic.clinicAddress.plot}, `}
              {clinic.clinicAddress.area && `${clinic.clinicAddress.area}, `}
              {clinic.clinicAddress.street &&
                `${clinic.clinicAddress.street}, `}
              {clinic.clinicAddress.landMark &&
                `${clinic.clinicAddress.landMark}, `}
              {clinic.clinicAddress.city?.name &&
                `${clinic.clinicAddress.city.name}, `}
              {clinic?.clinicAddress?.state?.name &&
                `${clinic.clinicAddress.state.name}, `}
              {clinic.clinicAddress.country?.name &&
                `${clinic.clinicAddress.country.name}, `}
              {clinic.clinicAddress.pin && clinic.clinicAddress.pin}
            </>
          ) : (
            "N/A"
          )}
        </span>
        <small className="d-block mt-1">
          <strong>Website</strong> : {clinic?.hospitalInfo?.web_address}
        </small>
        <small className="d-block mt-1">
          <strong>Contact No</strong> :{clinic?.userId?.phone}
        </small>
        <small className="d-block mt-1">
          <strong>GSTIN</strong> : {clinic?.accountInfo?.gst}
        </small>
      </div>
      <div className="mt-1 col-xl-12">
        <small className="mt-1 ms-2">
          <strong>From: </strong>Madalinskiego
        </small>
        <small className="mt-1 ms-2">Madalinskiego 8</small>,
        <small className="mt-1 ms-2">Madalinskiego 8</small>,
        <small className="mt-1 ms-2">Madalinskiego 8</small>,
        <small className="mt-1 ms-2">71-101 Szczecin, Poland</small>,
        <small className="mt-1 ms-2">
          <strong>Email: </strong>info@webz.com.pl
        </small>
        ,
        <small className="mt-1 ms-2">
          <strong>Phone: </strong>+48 444 666 3333
        </small>
        ,
      </div>
    </div>
  );

  const invoiceHeaderFullWidth = () => (
    <div className={classNames("row", styles.radiologyInvoice)}>
      <div className="mt-1 col-sm-5">
        <div className="brand-logo mb-3">
          <img
            className="logo-abbr me-2"
            src={clinic?.hospitalInfo?.pdfHeader}
            alt=""
          />
        </div>
      </div>
      <div className="mt-1 col-sm-5">
        <span className="d-block">
          {clinic?.clinicAddress ? (
            <>
              {clinic.clinicAddress.plot && `${clinic.clinicAddress.plot}, `}
              {clinic.clinicAddress.area && `${clinic.clinicAddress.area}, `}
              {clinic.clinicAddress.street &&
                `${clinic.clinicAddress.street}, `}
              {clinic.clinicAddress.landMark &&
                `${clinic.clinicAddress.landMark}, `}
              {clinic.clinicAddress.city?.name &&
                `${clinic.clinicAddress.city.name}, `}
              {clinic?.clinicAddress?.state?.name &&
                `${clinic.clinicAddress.state.name}, `}
              {clinic.clinicAddress.country?.name &&
                `${clinic.clinicAddress.country.name}, `}
              {clinic.clinicAddress.pin && clinic.clinicAddress.pin}
            </>
          ) : (
            "N/A"
          )}
        </span>
        <small className="d-block mt-1">
          <strong>Website</strong> : {clinic?.hospitalInfo?.web_address}
        </small>
        <small className="d-block mt-1">
          <strong>Contact No</strong> :{clinic?.userId?.phone}
        </small>
        <small className="d-block mt-1">
          <strong>GSTIN</strong> : {clinic?.accountInfo?.gst}
        </small>
      </div>
      <div className="mt-1 col-sm-2 text-end">
        {clinic?.hospitalInfo?.displayISOlogo && (
          <img
            src={clinic?.hospitalInfo?.ISOLogo}
            className="img-fluid width110"
            alt=""
            style={{ width: "70px" }}
          />
        )}
      </div>
      <div className="mt-2 col-xl-12">
        <small className="mt-1 ms-2">
          <strong>From: </strong>Madalinskiego
        </small>
        <small className="mt-1 ms-2">Madalinskiego 8</small>,
        <small className="mt-1 ms-2">Madalinskiego 8</small>,
        <small className="mt-1 ms-2">Madalinskiego 8</small>,
        <small className="mt-1 ms-2">71-101 Szczecin, Poland</small>,
        <small className="mt-1 ms-2">
          <strong>Email: </strong>info@webz.com.pl
        </small>
        ,
        <small className="mt-1 ms-2">
          <strong>Phone: </strong>+48 444 666 3333
        </small>
        ,
      </div>
    </div>
  );

  return (
    <>
      <Row
        className={
          showPDF ? styles.radiologyWrapper : styles.radiologyWrapperTwo
        }
      >
        <div className="col-lg-12">
          <div
            className={classNames(styles.radiologyCard, "card")}
            style={{
              backgroundImage: `url(${clinic?.hospitalInfo?.waterMark})`,
              height: "234vh",
            }}
            ref={reportRef}
          >
            <div className="card-body mb-auto position-relative">
              {clinic?.hospitalInfo?.headerAlignment === "left" &&
                invoiceHeaderLeft()}
              {clinic?.hospitalInfo?.headerAlignment === "right" &&
                invoiceHeaderRight()}
              {clinic?.hospitalInfo?.headerAlignment === "center" &&
                invoiceHeaderCenter()}
              {clinic?.hospitalInfo?.headerAlignment === "headerFullWidth" &&
                invoiceHeaderFullWidth()}
              <div className="col-sm-12 mb-2 mt-4">
                <div
                  style={{ backgroundColor: "#40be47", padding: "1px" }}
                ></div>
              </div>
              <div className={styles.radiologyDiv}>
                <h4>{newRadiologyReport?.radiologyServiceInfo?.serviceName}</h4>
                {newRadiologyReport?.radiologyServiceInfo?.serviceDetails?.map(
                  (item, index) => (
                    <div className={styles.radiologyUldiv} key={index}>
                      <h5>{item?.serviceDetailsName}:</h5>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(item?.description),
                        }}
                        className={styles.subheadingDiv}
                      />
                    </div>
                  ),
                )}
              </div>
            </div>
            <div style={{ position: "absolute", bottom: "0", width: "100%" }}>
              <div className="pb-2 ps-5 pe-0 d-flex justify-content-between position-relative">
                <div>
                  <b
                    style={{
                      fontSize: "0.9rem",
                      position: "absolute",
                      bottom: "0.6rem",
                    }}
                  >
                    Billed By : SimpleeKare
                  </b>
                </div>
                <div style={{ paddingRight: 35, marginTop: 10 }}>
                  <div className="d-flex flex-column align-items-center justify-content-center">
                    <div
                      style={{
                        // backgroundImage: `url(${newLabReport?.assignedPhysician?.signature})`,
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        width: "150px",
                        height: "70px",
                        objectFit: "cover",
                      }}
                    ></div>
                    <b style={{ fontSize: "0.95rem" }}>Signature</b>
                  </div>
                </div>
              </div>
              <div className="row pb-4 ps-5 pe-5">
                <div
                  style={{ backgroundColor: "#40be47", padding: "1px" }}
                ></div>
                <div className="col-sm-12 p-0 mt-4">
                  <div className="brand-logo d-flex align-items-center justify-content-between">
                    <img
                      className="logo-abbr me-2"
                      src={qrcode}
                      alt=""
                      style={{ width: "80px" }}
                    />
                    <b style={{ fontSize: "0.85rem" }}>
                      * No Extra Amount to be paid apart from Billing Amount.
                    </b>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Row>
      <button
        className="btn btn-primary mt-3 text-white"
        onClick={downloadInvoice}
      >
        Download PDF
      </button>
    </>
  );
};

export default RadiologyPDF;
